module.exports = __webpack_public_path__ + "static/media/dragon.d1a32bd6.png";